module.exports = __webpack_public_path__ + "img/용산역 와인바.270baf60.png";